// ==========================================================================
// FAQ Accordion Module (jQuery version)
// ==========================================================================

import $ from 'jquery';
import faqData from '../../data/faq-data.js';

// アイコンのパスを定数として定義
const iconPlusGreenWhite = './assets/images/faq/icon_plus_green_white.svg';
const iconPlusPinkWhite = './assets/images/faq/icon_plus_pink_white.svg';
const iconPlusGreen = './assets/images/common/icon_plus_green.svg';
const iconPlusPink = './assets/images/common/icon_plus_pink.svg';

export default class FAQ {
	constructor() {
		this.$container = $('.faq_categories');
		this.data = null;

		if (!this.$container.length) return;

		this.init();
	}

	init() {
		try {
			// JSONデータを設定
			this.data = faqData;

			// FAQをレンダリング
			this.render();

			// イベントリスナーを設定
			this.attachEventListeners();
		} catch (error) {
			console.error('FAQ data loading error:', error);
		}
	}

	render() {
		if (!this.data || !this.data.categories) return;

		// タイトルを更新
		const $titleElement = $('.faq_title');
		if ($titleElement.length && this.data.title) {
			$titleElement.text(this.data.title);
		}

		// カテゴリーをレンダリング
		this.$container.html(this.data.categories.map((category, categoryIndex) => {
			const colorClass = category.color === '#f37f80' ? 'is-pink' : '';
			const iconSrc = category.color === '#f37f80' ? iconPlusPinkWhite : iconPlusGreenWhite;

			return `
				<div class="faq_category" data-category="${category.id}">
					<div class="faq_category_header ${colorClass}" data-category-index="${categoryIndex}">
						<h3 class="faq_category_title">${category.title}</h3>
						<div class="faq_category_icon">
							<img src="${iconSrc}" alt="開閉" loading="lazy">
						</div>
					</div>
					<div class="faq_category_content" style="display: none;">
						${category.questions.map((question, questionIndex) => this.renderQuestion(question, questionIndex, colorClass)).join('')}
					</div>
				</div>
			`;
		}).join(''));
	}

	renderQuestion(question, questionIndex, colorClass) {
		const hasAnswer = question.answer && question.answer.trim() !== '';

		return `
			<div class="faq_question ${colorClass}" data-question-index="${questionIndex}">
				<div class="faq_question_header">
					<div class="faq_question_icon">
						<p class="faq_question_icon_text">Q</p>
					</div>
					<p class="faq_question_text">${question.question}</p>
					<div class="faq_question_toggle">
						<img src="${colorClass === 'is-pink' ? iconPlusPink : iconPlusGreen}" alt="開閉" loading="lazy">
					</div>
				</div>
				${hasAnswer ? `
					<div class="faq_answer" style="display: none;">
						<div class="faq_answer_icon">
							<p class="faq_answer_icon_text">A</p>
						</div>
						<div class="faq_answer_content">
							<p class="faq_answer_text">${question.answer}</p>
							${question.images && question.images.length > 0 ? `
								<div class="faq_answer_images">
									${question.images.map(image => `
										<div class="faq_answer_image">
											<img src="${image.src}" alt="${image.caption}" loading="lazy">
											<p class="faq_answer_image_caption">${image.caption}</p>
										</div>
									`).join('')}
								</div>
							` : ''}
						</div>
					</div>
				` : ''}
			</div>
		`;
	}

	attachEventListeners() {
		// カテゴリーの開閉
		this.$container.on('click', '.faq_category_header', (e) => {
			const $header = $(e.currentTarget);
			this.toggleCategory($header);
		});

		// 質問の開閉
		this.$container.on('click', '.faq_question_header', (e) => {
			const $header = $(e.currentTarget);
			this.toggleQuestion($header);
		});
	}

	toggleCategory($header) {
		const $category = $header.closest('.faq_category');
		const $content = $category.find('.faq_category_content');

		// アイコン回転のためのクラストグル
		$header.toggleClass('is-open');
		$content.toggleClass('is-open');

		// slideToggleでアニメーション（500msで統一）
		$content.slideToggle(500);
	}

	toggleQuestion($header) {
		const $question = $header.closest('.faq_question');
		const $answer = $question.find('.faq_answer');

		if (!$answer.length) return;

		// アイコン回転のためのクラストグル
		$question.toggleClass('is-open');
		$answer.toggleClass('is-open');

		// slideToggleでアニメーション（500msで統一）
		$answer.slideToggle(300);
	}
}

// Initialize FAQ
document.addEventListener('DOMContentLoaded', () => {
	new FAQ();
});
